define(['underscore', 'text!./templates/country-chooser.html'],
    (_, templateStr) => {
        return [
            function () { // NOSONAR
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {
                        /** Model (value) to select. */
                        model: '=',
                        /** Should the button select be disabled ? */
                        disabledIf: '=',
                        /** Codes for countries to be displayed as buttons  */
                        buttonCountriesCodes: '=',
                        /** Codes for countries to be displayed as favourites, before a separator, and sorted  */
                        favouriteCountriesCodes: '=',

                    },
                    controller: ['$scope', function ($scope) {

                        // Add the button countries at first
                        $scope.buttonCountries = [];
                        for (let i = 0; i < $scope.buttonCountriesCodes.length; i++) {
                            const buttonCountry = _.findWhere($scope.model.aspects.availableValues, {code: $scope.buttonCountriesCodes[i]});
                            $scope.buttonCountries.push(buttonCountry);
                        }

                        // We need to repriorize the typekey in portals. First countries will have an specific priority,
                        // The separartor will always follow this first list of countries, and rest of countires
                        // will all have the same priority in order to be sorted by the second critery (name).


                        // Then add the favourite countries in the dropdown
                        $scope.favouriteCountries = [];
                        let index = 0;
                        for (; index < $scope.favouriteCountriesCodes.length; index++) {
                            const favouriteCountry = _.findWhere($scope.model.aspects.availableValues, {code: $scope.favouriteCountriesCodes[index]});
                            favouriteCountry.priority = index;
                            $scope.favouriteCountries.push(favouriteCountry);
                        }

                        // Insert a separator between favourite countries and others
                        $scope.separator = ({code: 'separator', name: '──────────', priority: index++});

                        // Creating a list of other countries different from countries to display as button, and favourite countries
                        $scope.otherCountries = [];
                        // Add all the other coutries we still don't have
                        for (let i = 0; i < $scope.model.aspects.availableValues.length; i++) {
                            if ($scope.buttonCountriesCodes.indexOf($scope.model.aspects.availableValues[i].code) < 0 &&
                                $scope.favouriteCountriesCodes.indexOf($scope.model.aspects.availableValues[i].code) < 0) {
                                const countryToPush = $scope.model.aspects.availableValues[i];

                                // Assigning the same priority to all "other countries"
                                $scope.otherCountries.push(countryToPush);
                            }
                        }


                        /*
                         * The list of countries to display in the droplist have to be regenerated after the language is set/changed
                         */
                        $scope.$on('$localeChangeSuccess', () => {
                            $scope.regenerateCountryList();
                        });


                        /*
                         * This function regenerates the list of countries to display in the droplist after the locale is set/changed
                         * Bear in mind that "other countries' list depend on the language selected to be ordered
                         */
                        $scope.regenerateCountryList = () => {

                            $scope.listOfCountries = [];

                            _.each(_.sortBy($scope.favouriteCountries, 'priority'), (element) => {
                                $scope.listOfCountries.push(element);
                            });

                            $scope.listOfCountries.push($scope.separator);
                            const others = _.sortBy($scope.otherCountries, 'name');
                            _.each(others, (element) => {
                                $scope.listOfCountries.push(element);
                            });
                        };

                        function _isButtonCountrySelected() {
                            let isButtonCounty = false;
                            //check if value is a button country
                            for (let i = 0; i < $scope.buttonCountriesCodes.length; i++) {
                                if ($scope.model.value.code === $scope.buttonCountriesCodes[i]) {
                                    isButtonCounty = true;
                                }
                            }
                            return isButtonCounty;
                        }

                        $scope.countryListItemSelected = () => {
                            return $scope.model.value && !_isButtonCountrySelected() ? 'active' : '';
                        };

                        $scope.buttonCountrySelectClass = () => {
                            if ($scope.model.value) {
                                const isButtonCounty = _isButtonCountrySelected();
                                return isButtonCounty ? 'ng-isolate-scope gw-pl-select' : ' active';
                            }
                        };

                        // The list needs to be regenerated, to handle the rollback scenario.
                        $scope.regenerateCountryList();
                    }],
                };
            }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/CountryChooser.js